import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ReplaySubject, firstValueFrom, takeUntil } from 'rxjs';
import { SpswModel } from 'src/app/models/spsw.model';
import { YouthWorkerModel } from 'src/app/models/youth-workers.model';
import { StudentPortalService } from 'src/app/services/student-portal.service';

@Component({
  selector: 'app-youth-worker-card',
  templateUrl: './youth-worker-card.component.html',
  styleUrls: ['./youth-worker-card.component.scss']
})
export class YouthWorkerCardComponent implements OnInit {

  constructor(
    private _sanitizer: DomSanitizer,
    private _studentPortal: StudentPortalService
  ) { }

  @Input() youthWorkerData: SpswModel;
  @Input() isPrimaryYouthWorker: boolean;

  avatarUrl: SafeUrl = '';
  noAvatarUrlFound = false;

 async ngOnInit(): Promise<void> {
    try {
      if (this.youthWorkerData && this.youthWorkerData.avatarId) {
        await this.getAvatar(this.youthWorkerData.avatarId);
      } else {
          this.noAvatarUrlFound = true;
      }
    } catch(error) {
      console.error('Error fetching data:', error);
    }
  }

  get pickedBackground() {
    if (!this.youthWorkerData || !this.youthWorkerData?.preferences) {
        return '';
    }
    return JSON.parse(this.youthWorkerData.preferences)['backgroundColour'];
  }

  get avatarId() {
    if (!this.youthWorkerData || !this.youthWorkerData?.preferences) {
      return 0;
    }
    return this.youthWorkerData.avatarId;
  }

  async getAvatar(avatarId: number) {
    const avatar = await firstValueFrom(
        this._studentPortal.getStaffAvatar(avatarId)
    );
    const sanatizedUrl = this._sanitizer.bypassSecurityTrustUrl(
        URL.createObjectURL(avatar)
    );
    this.avatarUrl = sanatizedUrl;
}

  getOnLeaveStatusOpacity() {
    if(this.youthWorkerData.statusId != 2 && this.youthWorkerData.statusId != 3) {
      return {
        'opacity': '50%'
      };
    } else {
      return {
        'opacity': '100%'
      };
    }
  }

  getOnLeaveStatusTagStyle() {
    if(this.youthWorkerData.statusId != 2 && this.youthWorkerData.statusId != 3) {
      return {
        'visibility': 'visible',
      };
    } else {
      return {
        'visibility': 'hidden'
      }
    }
  }

}
